import React from 'react';
import ReactDOM from 'react-dom/client';
import Default from './pages/Default';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(<Default />);